import { AttributesMixin, define, Model, type } from "@type-r/models";

const defaultSort = {
    attr: "createdOn",
    asc: false
};

export const SortOptions = {
    createdOn: 'Created On',
    updatedOn: 'Updated On'
}


export interface NotificationSubscriptionsFilters extends AttributesMixin<typeof NotificationSubscriptionsFilters> { }

@define
export class NotificationSubscriptionsFilters extends Model {
    static attributes = {
        filterAll: '',
        sortBy: type(defaultSort),
        asc: false
    }

    reset() {
        this.filterAll = '';
    }

    mapToQuery(skip: number = 0, take: number = 1000) {
        const params: any = { skip: skip, count: take, platformCode: 'LQX'};

        if (this.filterAll && this.filterAll.length > 2)
        {
            params.quickSearch = this.filterAll;
        }

        if (this.sortBy)
        {
            params.sortBy = this.sortBy.attr;
            params.asc = this.sortBy.asc;
            params.sortDirection = this.sortBy.asc ? 'asc' : 'desc';
        }
        return params;
    }
}
